import { render, staticRenderFns } from "./Personalization.vue?vue&type=template&id=58d3643a&scoped=true"
import script from "./Personalization.vue?vue&type=script&lang=js"
export * from "./Personalization.vue?vue&type=script&lang=js"
import style0 from "./Personalization.vue?vue&type=style&index=0&id=58d3643a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d3643a",
  null
  
)

/* custom blocks */
import block0 from "./Personalization.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports